module.exports = __webpack_public_path__ + "assets/img/DS-living dinning (5).dacda09e.jpg";